import React, { Component } from "react";
import { DKLabel, DKButton, DKSpinner } from "deskera-ui-library";

import RouteManager from "../../managers/RouteManager";
import DashboardCard from "../common/Dashboard/DashboardCard";
import AttendanceCard from "../common/Dashboard/AttendanceCard";
import { TABLES, PRODUCTS, TableManger } from "../../managers/TableManger";
import Table from "../../services/table";
import JobPipelineService from "../common/Dashboard/JobPipeline";
import SetupDetails from "../common/Dashboard/SetupDetails";
import { ADMIN } from "../../managers/common/RouteAuth";
import ViewEmployee from "../employee/ViewEmployee";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import { withTranslation } from "react-i18next";
import ic_settings from "../../assets/icons/ic_settings.png"
import CardRearrangePopup from "../common/Dashboard/CardRearrangePopup";
import Utility from "../../utility/Utility";
import DashboardService from "../../services/Dashboard";
import { connect } from "react-redux";
import { isModuleRestricted, isShowDasboardCard, MODULE_ACCESS } from "../module-access-control/ModuleAccessControlConstants";
import UserDetails from "../common/Dashboard/UserDetails";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import PermissionUtils from "../user-permissions/PermissionUtils";

const MODULES = [
  {
    name: TABLES.CANDIDATE,
    isGraphDesign: false,
  },
  {
    name: TABLES.JOB_PIPELINE,
    isGraphDesign: false,
  },
  {
    name: TABLES.JOB_FORMS,
    isGraphDesign: false,
  },
  {
    name: TABLES.PEOPLE_EXPENSE_PENDING_CLAIMS,
    isGraphDesign: false,
  },
  {
    name: PRODUCTS.EXPENSE_TREND,
    isGraphDesign: true,
  },
  {
    name: TABLES.PEOPLE_EXPENSE_APPROVED_CLAIMS,
    isGraphDesign: true
  },
  {
    name: TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_GROUP,
    isGraphDesign: true
  },
  {
    name: TABLES.PEOPLE_EXPENSE_CLAIMS_BREAKDOWN_CATEGORY,
    isGraphDesign: true
  },
  {
    name: TABLES.PEOPLE_EXPENSE_MY_CLAIMS,
    isGraphDesign: false
  },
  {
    isGraphDesign: false,
    name: TABLES.TEAM_ATTENDANCE,
  }
  // {
  //   name: PRODUCTS.PAYROLL,
  //   isProduct: true
  // },
  // {
  //   name: PRODUCTS.ELEAVE,
  //   isProduct: true
  // },
  // {
  //   name: PRODUCTS.EXPENSE,
  //   isProduct: true
  // }
];
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showRearrangePopup: false,
      sequence: null
    }
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    this.fetchTotalPipelineData();
    this.fetchDashboardSettings();
    this.setState({showRearrangePopup: false});
  }

  showUserDetails() {
    return TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) &&
    PermissionUtils.USER_ROLE?.isSystemRole &&
    this.props.accessedBy === ADMIN &&
    !isMobileWebView()
  }

  render() {
    return (
      <div className="parent-width">
        <div className="row justify-content-between">
          <DKLabel text={this.props.t("DASHBOARD")} className="fw-m fs-l" />
          {this.props.accessedBy === ADMIN && this.state.sequence?.length > 0 && <DKButton title="Rearrange" className="border-m bg-white" icon={ic_settings}
          onClick={() => this.toggleChartRearrangePopup()} />}
        </div>
        <div className="row bg-deskera-secondary p-r border-radius-m border-m mt-m justify-content-between banner-holder">
          <DKLabel text='<span style=" font-size:18px">🧑🏻‍💻</span> Visit out community center to get all updates and learn about People+ <span style=" font-size:18px">🎉</span>' />
          <div>
            <div className="row flex-wrap">
              <DKButton
                className="border-m bg-white"
                title="Join Community 👏 "
                onClick={() => {
                  window.open(
                    "https://www.facebook.com/groups/deskera/",
                    "_blank"
                  );
                }}
              />
              <DKButton
                className="border-m ml-r vertical-spacing bg-white"
                title="Learn People+ 🙇‍♂️"
                onClick={() => {
                  window.open(
                    "https://www.deskera.com/blog/tag/people/",
                    "_blank"
                  );
                }}
              />
            </div>
          </div>
        </div>
        {!isMobileWebView() && <AttendanceCard/>}
        {this.props.accessedBy === ADMIN && !isMobileWebView() && this.showOnboardingSteps() && <SetupDetails {...this.props} />}
        {this.showUserDetails() && <UserDetails {...this.props} />}
        {this.props.accessedBy === ADMIN &&
          <div className="row flex-wrap dashboard-card-wrapper pb-xxl align-items-stretch" style={{columnGap: "2%"}}>
            {this.state.sequence != null && this.state.sequence.map(module => 
              (module.visible != null ? module.visible : true) && 
              <DashboardCard key={module.name} module={module.name} isGraphDesign={module.isGraphDesign} />
            )}
          </div>
        }
        {this.props.accessedBy !== ADMIN && <ViewEmployee  {...this.props}/>}
        {this.state.showRearrangePopup && (
          <CardRearrangePopup onClose={() => this.toggleChartRearrangePopup()} sequence={this.state.sequence}
            onSequenceChange={(sequence) => this.onSequenceChange(sequence)} />
        )}
      </div>
    );
  }

  onSequenceChange(sequence) {
    this.setState({sequence});
    this.updateDashboardSettings(sequence);
  }

  toggleChartRearrangePopup() {
    this.setState({showRearrangePopup: !this.state.showRearrangePopup});
  }

  fetchTotalPipelineData() {
    const pipelineTableId = TableManger.getTableId(TABLES.JOB_PIPELINE);
    Table.getRecords(pipelineTableId).then(
      (res) => {
        JobPipelineService.pipelineData = res;
        this.fetchTotalStageData();
      }
    );
  }

  fetchTotalStageData() {
    const stageTableId = TableManger.getTableId(TABLES.JOB_STAGE);
    Table.getRecords(stageTableId).then(
      (res) => {
        JobPipelineService.stageData = res;
      }
    );
  }

  fetchDashboardSettings() {
    DashboardService.getDashboardSetting().then(response => {
      if(response?.dashboardSettingsPeople?.order?.length > 0) {

        // Check for all dashbaord widget exist
        this.checkAndUpdateNewWidget(response.dashboardSettingsPeople.order)
        this.checkWidgetAcccess(response.dashboardSettingsPeople.order);
      } else {
        // IF no widget then call for update all.
        this.updateDashboardSettings(MODULES)
        this.checkWidgetAcccess(MODULES);
      }
    }).catch(err => {
      this.checkWidgetAcccess(MODULES);
    })
  }

  checkWidgetAcccess(modules) {
    let updatedModules = [];
    if (Array.isArray(modules)) {
      updatedModules = modules.filter((m) => {
        return isShowDasboardCard(this.props.moduleAccessControl, m);
      });
    }

    this.setState({sequence: updatedModules});
  }

  showOnboardingSteps() {
    return !(
      isModuleRestricted(this.props.moduleAccessControl, MODULE_ACCESS.COMPANY_SETTINGS) ||
      isModuleRestricted(this.props.moduleAccessControl, MODULE_ACCESS.PAYROLL)
    )
  }

  checkAndUpdateNewWidget(oldDashbaordWidget) {
    let newDashboardWidget = []
    if (oldDashbaordWidget) {
      MODULES.forEach(m => {
        let widget = oldDashbaordWidget.find(o => o.name === m.name)
        if (widget && !Utility.isEmpty(widget.name)) {
          // confinue;
        } else {
          newDashboardWidget.push(m)
        }
      })
    }
    if (newDashboardWidget.length != 0) {
      this.updateDashboardSettings([...oldDashbaordWidget, ...newDashboardWidget])
    }
  }

  updateDashboardSettings(sequence) {
    const data = {dashboardSettingsPeople: {order: sequence}};
    console.log(JSON.stringify(data));
    DashboardService.updateDashboardSetting(data).then(response => {
      if(response?.success) {
        this.fetchDashboardSettings();
      }
    }).catch(err => {})
  }
}

const mapStateToProps = (state) => ({
  moduleAccessControl: state.moduleAccessControl?.data
});

export default connect(mapStateToProps)(withTranslation()(Dashboard));

export const getDashboardWidgetLoading = () => {
  return (
    <div className="parent-width parent-height row justify-content-center">
      <DKSpinner title="Loading..." />
    </div>
  );
};
